import React, { FC, memo } from "react";
import { ThemeProvider } from "@mui/material";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { genTheme } from "@ui";
import AppRoute from "../AppRoute/AppRoute";

import { I18nextProvider } from "react-i18next";
import i18n from "@i18n/i18n";

const CoreProvider: FC = (props) => {
  return (
    <ThemeProvider theme={genTheme}>
      <LocalizationProvider dateAdapter={AdapterDateFns}>
        <I18nextProvider i18n={i18n} />
        <AppRoute />
      </LocalizationProvider>
    </ThemeProvider>
  );
};

export default memo(CoreProvider);
